import styled from "styled-components";

interface TextProps {
  selected?: boolean;
}

export const FlexContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-content: flex-start;
`;

export const ModalTitle = styled.div`
  margin-top: 10px;    
  font-weight: 600;
  font-size: 18px;
  color: #808080;
  margin-bottom: 4px;
`;

export const ModalHelpText = styled.div`
  color: #808080;
`;

export const Text = styled.span<TextProps>`
  font-size: 18px;
  color: ${props => (props.selected ? props.theme.orangeBackground : "#808080")};
  font-weight: ${props => (props.selected ? 700 : 400)};
  margin-bottom: 4px;
  cursor: ${props => (props.selected ? "default" : "pointer")};

  &::first-letter {
    text-transform: capitalize;
  }

  &:hover {
    color: ${props => (props.selected ? props.theme.orangeBackground : "#404040")};
  }
`;

export const StyledSelect = styled.select`
  min-width: 158px;
  height: 29px;
  margin-right: 50px;
  padding-right: 36px;
  padding-left: 10px;
  background-color: ${({ theme }) => theme.orangeBackground};
  border: none;
  border-radius: 15px;
  font-weight: 600;
  color: #fff;

  // Replace arrow
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,<svg width='17' height='11' viewBox='0 0 17 11' fill='none' xmlns='http://www.w3.org/2000/svg'> <path d='M1.9975 0.264404L8.5 6.75274L15.0025 0.264404L17 2.2619L8.5 10.7619L3.89524e-07 2.2619L1.9975 0.264404Z' fill='white'/> </svg>");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 17px;
`;

export const StyledOption = styled.option`
  background-color: #fff;
  color: #000;
`;

export const ModalAction = styled.div`
  width: fit-content;
  font-size: 12px;
  color: #008c6b;
  cursor: pointer;
`;

export const Separator = styled.span`
  margin: 0 3px;
`;
